import { Component, Output, EventEmitter, Input } from '@angular/core';
import { NavController, ModalController, NavParams, Events } from 'ionic-angular';
import { UploadResumePopupComponent } from '../upload-resume-popup/upload-resume-popup.component';
import { CandidateProfileComponent } from '../../../candidate-profile/candidate-profile.component';
import { JobApplyObject } from '../../../../../../../UI/src/app/shared/job/job-apply-object.dto';
import { JobService } from '../../../../../../../UI/src/app/shared/job/job.service';
import { ProfileService } from '../../../../../../../UI/src/app/shared/profile/profile.service';
import { JobDetailsPage } from '../../../job-search/components/job-details/job-details.component';
import { SettingsService } from '../../../../../../../UI/src/app/shared/settings/settings.service';
import { LocationStrategy } from '@angular/common';
import { UploadResumeService } from '../../../../../../../UI/src/app/shared/upload-resume/upload-resume.service';
import { SitemapService } from '../../../../../../../UI/src/app/shared/sitemap/sitemap.service';
import { ToastControllerService } from '../../../../../providers/toast-controller.service';
import { TranslateService } from '@ngx-translate/core';
import { Storage } from '../../../../../../../UI/src/app/shared/constants';
import { Toast508Service } from '../../../../../providers/toast-508.service';
import { EditProfileComponent } from '../../../edit-profile/edit-profile.component';
import { ResumeService } from '../../../../../../../UI/src/app/shared/resume/resume.service';
import { AuthenticationComponent } from '../../authentication.component';
import { AuthenticationService } from '../../../../../../../UI/src/app/shared/authentication/authentication.service';

@Component({
  selector: 'sts-add-resume',
  templateUrl: './add-resume.component.html'
})
export class AddResumeComponent {
  @Output() callBack = new EventEmitter<any>();
  @Input() stepControl: boolean;
  @Input() isApplyWithLinkedIn = false;
  @Input() resumeDetails: any;
  @Input() isResumeRequired = false;
  @Input() isResumeExists = false;
  disableSubmit: boolean = true;
  private accessCode: string;
  private alertData: any;
  public job: any;
  private showNavBar: boolean = true;
  private indeedClientSetting: any;
  private partnerAccountSettings: any;
  public action: string = '';
  public enableLinkedInSetting: any;
  public enableLinkedInAlternateResumeSetting: any;
  public enableIndeedSetting: any;
  private indeedKey = 'REC_INDEED_CLIENTID';
  private enableLinkedIn = 'REC_ENABLE_LINKEDIN';
  private enableLinkedInAlternateResume = 'REC_ENABLE_LINKEDIN_ALTERNATE_RESUME';
  private enableIndeed = 'REC_ENABLE_INDEED';
  private clientId = '';
  resumeExists = false;
  profileExists = false;
  distanceUnits : any;
  isResumeConfirmed = false;
  translations: any;
  public resumeAction: any;
  public navigatedFrom: any;
  fromEditResume = false;
  constructor(
    public navCtrl: NavController,
    public modalCtrl: ModalController,
    private jobService: JobService,
    private profileService: ProfileService,
    private navParams: NavParams,
    private settingsService: SettingsService,
    private locationStrategy: LocationStrategy,
    private uploadResumeService: UploadResumeService,
    private resumeService: ResumeService,
    private sitemapService: SitemapService,
    public events: Events,
    private toastService: ToastControllerService,
    private translate: TranslateService,
    private toast508Service: Toast508Service,
    private authenticationService: AuthenticationService
  ) {
    this.fromEditResume= this.resumeService.getFromEditResume();
    this.events.publish('showSiteMapNodes', true);
    this.action = navParams.get("action");
    this.resumeAction = this.resumeService.getResumeAction();
    if(this.navCtrl.getPrevious()) {
      this.navigatedFrom = this.navCtrl.getPrevious().name;
    }
    if (navParams.data == true)
      this.showNavBar = true;
    if (navParams.data.action == 'validate')
      this.showNavBar = false
  }

  ngOnInit() {
    /*Get all the Partner Account settings related to Upload Resume*/
    this.settingsService.GetSettings().subscribe(
      settings => {
        this.partnerAccountSettings = settings;
        this.enableLinkedInSetting = settings.filter(setting => setting.key === this.enableLinkedIn)[0].value;
        this.enableIndeedSetting = settings.filter(setting => setting.key === this.enableIndeed)[0].value;
      }
    );
    this.events.publish('showSiteMapNodes', true);
    this.accessCode = location.href.split('?code=')[1];
    if (this.accessCode != null && this.accessCode.indexOf('#') != -1)
      this.accessCode = this.accessCode.split('#')[0];

    if (window.localStorage.getItem(Storage.AUTH_TOKEN) != null) {
      this.profileExists = true;
      this.profileService.getProfileData().subscribe(
        (response) => {
          this.distanceUnits = response[0].distanceUnitCode;
          if (response[0].resumeType !== 0) {
            this.resumeExists = true;
            this.isResumeExists = true;
            this.isResumeConfirmed = response[0].isResumeConfirmed;
          }
        }, (error) => {
          // TODO : Implement alert
        }
      );
    }
    this.saveIndeed();
  }

  saveIndeed() {
    if (this.accessCode !== '' && this.accessCode !== undefined) {
      const redirectURI = location.href.split('?code=')[0];
      this.uploadResumeService.saveResumeData('indeed', this.accessCode, redirectURI, -1, '').subscribe(
        (response) => {
          this.translate.get(['CAREER_RESUME_INDEED_UPLOAD_SUCCESS', 'CAREER_RESUME_INDEED_UPLOAD_FAIL'])
            .subscribe((translationsObj) => {
              this.translations = translationsObj;
              if (response) {
                this.alertData = {
                  message: this.translations['CAREER_RESUME_INDEED_UPLOAD_SUCCESS'], type: 'success'
                };
                this.disableSubmit = false;
                if (!this.resumeExists) {
                  this.sitemapService.updateSitemapData();
                  this.resumeExists = true;
                }
                this.resumeService.setResumeAction({action: 'REVIEW_RESUME', isInititalCreation: true, isJobApply: this.resumeAction ? this.resumeAction.isJobApply : false, navigatedFrom: this.navigatedFrom});
                this.navCtrl.push(AuthenticationComponent, {"action": "REVIEW_RESUME", "isJobApply": this.resumeAction ? this.resumeAction.isJobApply : false});
              } else {
                this.alertData = { message: this.translations['CAREER_RESUME_INDEED_UPLOAD_FAIL'], type: 'warning' };
                this.disableSubmit = true;
              }
              this.toastService.presentToast(this.alertData);
              this.toast508Service.toFocus();
              this.events.publish('showSiteMapNodes', true);
            }, (error) => {
              this.alertData = { message: this.translations['CAREER_RESUME_INDEED_UPLOAD_FAIL'], type: 'warning' };
              this.disableSubmit = true;
              this.toastService.presentToast(this.alertData);
              this.toast508Service.toFocus();
            });
        });
    }
  }
  editLinkedInResume() {
    this.resumeService.setReviewAndConfirm(true);
    this.resumeService.setAddResumeFromScratch(false);
    this.resumeService.setFromGetMatched(false);
    this.resumeService.setFromEditResume(false);
    this.resumeService.setResumeAction({action: 'REVIEW_RESUME', isInititalCreation: false,
    isJobApply: true, navigatedFrom: "linkedin"});
    this.navCtrl.push(AuthenticationComponent, { "action": "REVIEW_RESUME"});
  }

  launchModalPopup(importFrom: string) {
    if (importFrom === 'indeed') {
      const indeedAuthAPI = 'https://secure.indeed.com/account/oauth?';
      const responseType = '&response_type=code';
      const redirectURI = '&redirect_uri=';
      const localHost = this.buildRedirectURI();
      let indeedAPIURL = '';
      const clientIdString = 'client_id=';
      this.indeedClientSetting = this.partnerAccountSettings.filter(setting => setting.key === this.indeedKey)[0];
      if (this.indeedClientSetting != null) {
        this.clientId = this.indeedClientSetting.value;
        indeedAPIURL = indeedAuthAPI + clientIdString + this.clientId + responseType + redirectURI + localHost;
        window.location.href = indeedAPIURL;
      }
    }
  }

  private buildRedirectURI(): string {
    let redirectString = location.href.split('#/')[0];
    if (redirectString.indexOf('?code=') != -1)
      redirectString = location.href.split('?code=')[0]
    else if (redirectString.indexOf('?error=') != -1)
      redirectString = location.href.split('?error=')[0]
    // else if (this.resumeAction) {
    //   redirectString = redirectString + "&action=" + this.resumeAction.action + "&isInititalCreation=" + this.resumeAction.isInititalCreation + "&isJobApply=" + this.resumeAction.isJobApply;
    //}
    return redirectString;
  }

  uploadResume() {
    // let uploadModal = this.modalCtrl.create(UploadResumePopupComponent);
    // uploadModal.onDidDismiss(data => {
    //   if (data != null && data.type == 'success') {
    //     this.disableSubmit = false;
    //   }
    //   else {
    //     this.disableSubmit = true;
    //   }
    //   if (this.navParams.data == true) {
    //     this.showNavBar = true;
    //   }
    //   else {
    //     this.showNavBar = false;
    //   }
    // });
    // uploadModal.present();
    this.navCtrl.push(UploadResumePopupComponent);
  }

  createResume() {
    if (this.resumeAction !== null ) {
    this.resumeService.setResumeAction({action: 'CREATE_RESUME', isInititalCreation:  this.resumeAction.isInititalCreation, isJobApply: this.isApplyWithLinkedIn ? this.isApplyWithLinkedIn : this.resumeAction.isJobApply, navigatedFrom: this.navigatedFrom});
    } else {
    this.resumeService.setResumeAction({action: 'CREATE_RESUME', isInititalCreation: true, isJobApply: false, navigatedFrom: this.navigatedFrom});
    }
    this.navCtrl.push(EditProfileComponent);
  }

  onSubmit() {
    const jobApplyObject: JobApplyObject = this.jobService.getApplyJobObject();
    if (jobApplyObject != null && jobApplyObject.JobId != null) {
      this.profileService.applyJob(jobApplyObject.JobId).subscribe(
        (response) => {
          if (response > 0) {
            this.jobService.setSuccessAlert(0);
          } else if (response === -1) {
            this.jobService.setSuccessAlert(1);
          } else if (response === -50) {
            this.jobService.setSuccessAlert(2);
          }
          this.navCtrl.push(JobDetailsPage, { jobId: jobApplyObject.JobId })
            .then(() => {
              const startIndex = this.navCtrl.getActive().index - 1;
              this.navCtrl.remove(startIndex, 1);
            });
          }, (error) => {
        }
      );
    } else {
      //TO DO: Check if 'wizardStep' is required.
      this.callBack.emit({wizardStep: '4'});
    }
  }

  cancelStep() {
    this.events.publish('showSiteMapNodes', true);
    this.authenticationService.isAppliedwithLinkedIn = false;
    this.disableSubmit = true;
    if (window.localStorage.getItem(Storage.AUTH_TOKEN) != null) {
      this.navCtrl.setRoot(CandidateProfileComponent);
    }
    else
      this.navCtrl.pop();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/authentication/components/add-resume/add-resume.component.ts